module.exports = __webpack_public_path__ + "static/media/logo (2).4d008abc.png";